import {Alert, Toast} from 'components';
import {isZaloMiniApp, stringApp, urlApp} from 'constant';
import * as Clipboard from 'expo-clipboard';
import * as ImagePicker from 'expo-image-picker';
import * as htmlToImage from 'html-to-image';
import I18n from 'languages/i18n';
import md5 from 'md5';
import moment from 'moment';
import {Linking, Platform} from 'react-native';
import {navigate} from 'services';
import {getStoreData, getStoreToken} from './storage';

const regEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const regPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9|#?!@$%^&*-]).{6,40}$/;
const regPhone = /([\+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/;
const regNumber = /^[0-9]*$/;

export const PostMSG = (msg: string, data: Object) => {
  const D = JSON.stringify({
    msg,
    data,
  });
  Log('post data', D);
  // Kiểm tra xem có đang nằm trong iframe không và window.parent có tồn tại không
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(D, '*');
  } else if (window.top) {
    window.top.postMessage(D, '*');
  }
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(D);
  }
};

export function detectLinkData(t: any) {
  const num = t?.indexOf('?');
  const ss = t?.slice(num + 1, t.length);
  let obj = {};
  ss.split('&')?.map((item: any, index: number) => {
    const gg = item?.split('=');
    obj[gg[0]] = gg[1];
  });
  return obj;
}

export const downloadQRCode = async (t: string | any) => {
  const node: HTMLElement | any = document.getElementById(t);
  htmlToImage
    .toPng(node)
    .then(function (dataUrl) {
      // console.log("dataUrl>>", dataUrl)
      PostMSG('DownloadQRCode', {
        base64: dataUrl,
      });
      const link = document.createElement('a');
      link.href = dataUrl;
      link.setAttribute('download', ` ${getUuid()}.png`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(function (error) {
      console.error('oops, something went wrong!', error);
    });
};

export const downloadFileWebview = async (p: {
  url: string;
  setLoading: (t: boolean) => void;
  fileName?: string;
}) => {
  try {
    p.setLoading(true);
    const url = `${urlApp.APIURL}api/${p.url}`;
    const token = await getStoreToken();
    const email = await getStoreData('email');
    const phone = await getStoreData('phone');
    const refCode = await getStoreData('refCode');
    const agentCode = await getStoreData('agentCode');
    const refKey = await getStoreData('refKey');
    // const email = 'manld1@fincorp.com.vn';
    // const phone = `0765000655`;
    // const refCode = `7292d7660bb1a5b7e214ca297ba04fe9fb3de293`;
    // const agentCode = `924`;
    // const refKey = `4a84351eab64d151a34df1573ec9d411b4c6163d`;

    const objjj = !!token
      ? {}
      : {
          email: email,
          phone: phone,
          refCode: refCode,
          agentCode: agentCode,
        };

    var headers: any = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...objjj,
      Authorization: token
        ? `Bearer ${token}`
        : `Bearer ${md5(`${email}${phone}${refCode}${agentCode}${refKey}`)}`,
    };
    const data = await fetch(url, {
      method: 'GET',
      headers: headers,
      // body: JSON.stringify(t.body),
    });
    const name: string =
      data?.headers
        ?.get(`content-disposition`)
        ?.replace('attachment; filename="', '')
        .replace(/"/g, '') || '';

    data.blob().then(async blob => {
      const urlFile = await getFileUrl(blob, p?.fileName || '');
      PostMSG('DownloadSignatureUrl', {
        url: urlFile,
        // fileName: fileName,
        // headers: headers,
      });

      PostMSG('DownloadSignatureFile', {
        blob: data,
      });
      let dataurl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = dataurl;
      a.download = name;
      a.click();
    });
  } catch (error: any) {
    Alert.showError({
      content: error.message,
      multilanguage: false,
    });
  } finally {
    p.setLoading(false);
  }
};

export const checkToSetNumber = (e: string, func: (r: string) => void) => {
  if (e.length == 0) {
    func(e);
    return;
  }
  const t: string = e[e.length ? e.length - 1 : 0] || '';
  if (regNumber.test(t)) {
    func(e);
  }
};

export const converRistInfoInDto = (t: any) => {
  const obj = {};
  Object.keys(t).map((item: any, index: number) => {
    obj[item] = t[item].id;
  });
  return obj;
};

export const checkApproveInvestmentProfile = (p: {
  currentUser: any;
  orderType: 'SELL' | 'TRANSFER' | 'BUY' | 'TRANSFER_BUY';
  initData: any;
  I18nState?: 'vi' | 'en';
}) => {
  // navigate('ControlEKYCScreen');
  // return;
  const {currentUser, orderType, initData, I18nState} = p;
  const {bankAccountIsFull, userInfoIsFull, userAddressIsFull} = currentUser;
  if (!currentUser?.investmentProfile?.status) {
    if (!userInfoIsFull && !bankAccountIsFull && !userAddressIsFull) {
      navigate('ControlEKYCScreen');
    } else {
      navigate('AccountVerifyScreen');
    }
    return;
  }
  if (
    (orderType == 'SELL' ||
      orderType == 'TRANSFER' ||
      orderType == 'TRANSFER_BUY') &&
    !currentUser?.investmentProfile?.isReceivedHardProfile
  ) {
    const content =
      I18nState == 'vi'
        ? `Tài khoản của quý khách hiện tại chưa được duyệt hoặc chưa nhận được hồ sơ gốc/chưa ký hợp đồng điện tử. Nên không thể thực hiện lệnh bán/ chuyển đổi.`
        : `You cannot create redemption/switching transaction due to pending account approval or not received hardcopy Open Account Contract/ unsigned e-Contract`;
    if (
      currentUser?.investmentProfile?.status?.code !=
        `INVESTMENT_PROFILE_APPROVE` ||
      (currentUser?.investmentProfile?.status?.code ==
        'INVESTMENT_PROFILE_APPROVE' &&
        !currentUser?.investmentProfile?.isReceivedHardProfile)
    ) {
      Alert.show({
        content: content,
        multilanguage: false,
        type: 2,
        titleClose: 'alert.dongy',
        onCancel: () => {},
        onConfirm: () => {
          navigate('DigitalSignatureScreen');
        },
      });
      return;
    }
  }
  navigate('CreateOrderModal', {
    orderType,
    initData,
  });
  return;
};

export function convertReceiveAmount(
  status: boolean,
  I18nState: 'en' | 'vi' | string,
) {
  if (status) {
    if (I18nState == 'vi') {
      return `Đã nhận tiền`;
    }
    return `Received money confirm`;
  }
  if (I18nState == 'vi') {
    return `Chờ xác nhận tiền`;
  }
  return `Waiting to confirm receiving money`;
}
export const convertDataDownloadFile = (
  r: any,
): {
  name: string;
  type: string;
  urlFile: string;
} => {
  return {
    name: ``,
    type: '',
    urlFile: '',
  };
  const link =
    Platform.OS === 'android'
      ? `${RNFS.DownloadDirectoryPath}/${stringApp.appLink}/`
      : `${RNFS.DocumentDirectoryPath}/`;
  const name: string = (
    r.respInfo.headers?.[`content-disposition`] ||
    r.respInfo.headers?.[`Content-Disposition`]
  )
    .replace('attachment; filename="', '')
    .replace(/"/g, '');
  const i = new Date().getTime();
  let type = `application/pdf`;
  if (!name.endsWith('pdf')) {
    type = `image/png`;
  }
  const urlFile = `${link}${i}-${name}`;
  return {
    name: `${i}-${name}`,
    type,
    urlFile,
  };
};

export const convertNumber = (num: number | string, hideD?: boolean) => {
  if (!num) return `${num}${hideD ? '' : ` ${stringApp.currency}`}`;
  const strhead = parseInt(`${num}`.replace(/[,]/g, '')) >= 0 ? '' : '-';
  const ar = Math.abs(
    typeof num == 'string' ? parseInt(num.replace(/[,]/g, '')) : num,
  )
    .toString()
    .split('.');
  const str = [...ar[0]]
    .reverse()
    .map((item, index) => {
      if (index % 3 == 2 && index < ar[0].length - 1) {
        return `,${item}`;
      }
      return item;
    })
    .reverse()
    .join('');

  return `${strhead}${str}${ar[1] ? `.${ar[1]}` : ''}${
    !!hideD ? '' : ` ${stringApp.currency}`
  }`;
};

export const convertStringVNTime = (I18nState: 'vi' | 'en') => {
  return '';
  return I18nState == 'vi' ? ' (Giờ VN)' : ' (VNT)';
};

export const convertAmount = (num: number | string, hideD?: boolean) => {
  if (!num) return `${num}${hideD ? '' : ` ${stringApp.currency}`}`;
  if (!parseInt(`${num}`)) {
    return '';
  }

  const strhead = parseInt(`${num}`?.replace(/[,]/g, '')) >= 0 ? '' : '-';
  const ar = Math.abs(
    typeof num == 'string' ? parseInt(num?.replace(/[,]/g, '')) : num,
  )
    .toString()
    .split('.');
  const isDot = `${num}`.indexOf('.');
  let last = '';
  if (isDot != -1) {
    last = `${num}`?.slice(isDot + 1, `${num}`.length)?.slice(0, 2);
  } else {
    last = '';
  }
  const str = [...ar[0]]
    .reverse()
    .map((item, index) => {
      if (index % 3 == 2 && index < ar[0].length - 1) {
        return `,${item}`;
      }
      return item;
    })
    .reverse()
    .join('');
  return `${strhead}${str}${isDot != -1 ? `.${last ?? ''}` : ''}${
    !!hideD ? '' : ` ${stringApp.currency}`
  }`;
};

export const convertNav = (num: number | string, hideD?: boolean) => {
  if (!num) return `${num}${hideD ? '' : ` ${stringApp.currency}`}`;
  const strhead = parseInt(`${num}`?.replace(/[,]/g, '')) >= 0 ? '' : '-';
  const ar = Math.abs(
    typeof num == 'string' ? parseInt(num?.replace(/[,]/g, '')) : num,
  )
    .toString()
    .split('.');
  const last =
    ar[1]?.length == 2
      ? `.${ar[1]}`
      : ar[1]?.length == 1
      ? `.${ar[1]}0`
      : `.00`;
  const str = [...ar[0]]
    .reverse()
    .map((item, index) => {
      if (index % 3 == 2 && index < ar[0].length - 1) {
        return `,${item}`;
      }
      return item;
    })
    .reverse()
    .join('');
  return `${strhead}${str}${last}${!!hideD ? '' : ` ${stringApp.currency}`}`;
};

export const convertPercent = (num: string | number | any) => {
  if (!`${num}`.length) {
    return '';
  }
  const per = Math.round(num * 100) / 100;
  const la = `${per}`?.split('.')?.[1] || '';
  const st = la?.length == 2 ? '' : la?.length == 1 ? '0' : '.00';
  return `${per}${st}%`;
};

export const isvalidEmail = (email: string) => {
  if (!email?.length) {
    return false;
  }
  return regEmail.test(email.toLocaleLowerCase());
};

export const isValidPassword = (password: string) => {
  return regPassword.test(password);
};

export const isvalidPhone = (phone: string) => {
  if (!phone?.length) {
    return false;
  }
  return regPhone.test(phone.toLocaleLowerCase());
};

export const parseMultilanguage = (text: string) => {
  return I18n.t(`${text}`);
};

export const checkRegisterValue = (p: {
  name: string;
  email: string;
  phone: string;
  province?: any;
}) => {
  if (
    !p.name.length ||
    !isvalidEmail(p.email) ||
    !isvalidPhone(p.phone)
    // || !p.province
  ) {
    return false;
  }
  return true;
};

export const checkPassword = (p: {
  oldPassword: string;
  newPassword: string;
  reNewPassword: string;
}) => {
  if (!p.oldPassword.length) {
    return false;
  }
  if (p.oldPassword == p.newPassword) {
    Alert.showError({
      content: `alert.matkhaucuphaikhacmatkhaumoi`,
    });
    return false;
  }
  if (p.newPassword !== p.reNewPassword) {
    return false;
  }

  if (!regPassword.test(p.newPassword)) {
    return false;
  }
  // regex check password;
  return true;
};
export const checkCreatePassword = (p: {
  password: string;
  confirmPassword: string;
}) => {
  if (!p.password || !p.confirmPassword) {
    return false;
  }
  if (p.password != p.confirmPassword) {
    return false;
  }
  if (!regPassword.test(p.password)) {
    Alert.showError({
      content: `setpasswordscreen.rule`,
    });
    return false;
  }
  return true;
};

export const checkEmail = (p: {
  oldEmail: string;
  newEmail: string;
  reNewEmail: string;
}) => {
  if (!p.oldEmail.length) {
    return false;
  }
  if (p.oldEmail == p.newEmail) {
    Alert.showError({
      content: `alert.emailcuphaikhacemailmoi`,
    });
    return false;
  }
  if (!isvalidEmail(p.newEmail)) {
    return false;
  }

  if (p.newEmail !== p.reNewEmail) {
    return false;
  }
  // regex check password;
  return true;
};

export const checkAddress = (p: {
  valueNation: any;
  valueProvince: any;
  address: string;
}) => {
  if (p.address?.length == 0) {
    return false;
  }
  if (!p.valueNation?.id) {
    return false;
  }
  if (!p.valueProvince?.id) {
    return false;
  }
  return true;
};

export const getNumdateCalenda = (p: {
  date?: number | string;
  month: number | string;
  year: number | string;
}) => {
  const gmonth =
    typeof p.month == 'string' ? parseInt(p.month || '0') : p.month;
  const gyear = typeof p.year == 'string' ? parseInt(p.year || '0') : p.year;
  if (gmonth == 2) {
    if ((gyear % 4 == 0 && gyear % 100 != 0) || gyear % 400 == 0) {
      return 29;
    }
    return 28;
  }
  if (gmonth == 4 || gmonth == 6 || gmonth == 9 || gmonth == 11) {
    return 30;
  }
  return 31;
};

export const parseArrayNum = (num: number, isYear?: boolean) => {
  const curryear = new Date().getFullYear();
  return Array(num)
    .fill(0)
    .map((item, index) => {
      const i = isYear ? curryear - num + index : index;
      return {
        id: `${i < 10 ? '0' : ''}${i + 1}`,
        name: `${i + 1}`,
        nameen: `${i + 1}`,
      };
    });
};

export const getUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const parseToFormData = (p: any) => {
  if (typeof p == 'object') {
    return Object.keys(p)?.map(item => {
      if (item == 'fileUpload') {
        return p[`${item}`];
      }
      return {
        name: item,
        data: typeof p[item] == 'string' ? p[item] : `${p[item]}`,
      };
    });
  }
  return [];
};

export const getImageCamera = async () => {
  return new Promise((resolve, reject) => {
    return ImagePicker.launchCameraAsync({
      quality: 1,
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      base64: true,
    })
      .then(async (res: any) => {
        if (res) {
          resolve([
            {
              ...res,
              base64: res.uri
                .replace('data:image/jpeg;base64,', '')
                .replace('data:image/png;base64,', ''),
            },
          ]);
          return;
        }
        reject();
      })
      .catch((err: any) => {
        reject();
        throw err;
      });
  });
};

export const getImageLibrary = async () => {
  return new Promise((resolve, reject) => {
    return ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      quality: 1,
      base64: true,
    })
      .then((res: any) => {
        if (res) {
          resolve([
            {
              ...res,
              base64: res.uri
                .replace('data:image/jpeg;base64,', '')
                .replace('data:image/png;base64,', ''),
            },
          ]);
          return;
        }
        reject();
      })
      .catch((err: any) => {
        reject();
        throw err;
      });
  });
};

export const requestPermisson = (permissions: any, callback: () => void) => {
  return;
};
export const joinObjectCalendar = (a: {
  date: number | string;
  month: number | string;
  year?: number | string;
  isPicker?: boolean;
}) => {
  if (a.isPicker) {
    const MM = `${parseInt(`${a.month}`) + 1}`;
    const DD = `${parseInt(`${a.date}`)}`;
    return `${a.year}${MM}${`${DD}`?.length >= 2 ? DD : `0${DD}`}`;
  }
  const MM = `${parseInt(`${a.month}`)}`;
  const DD = `${parseInt(`${a.date}`)}`;
  return `${a.year}${MM?.length >= 2 ? MM : `0${parseInt(MM)}`}${
    `${DD}`?.length >= 2 ? DD : `0${DD}`
  }`;
};

export const reJoinObjectCalendar = (a: string) => {
  const arr = a?.split('/');
  return {
    date: arr?.[0],
    month: arr?.[1],
    year: arr?.[2],
  };
};

export const convertTimestamp = (
  a: number | string,
  format?: string,
  localZone?: boolean,
) => {
  if (!a) {
    return '';
  }
  if (localZone) {
    return `${moment(a).format(format || 'DD/MM/yyyy')}`;
  }
  return `${moment(a)
    .utcOffset('+07:00')
    .format(format || 'DD/MM/yyyy')}`;
};

export const removeUtf8 = (s: string) => {
  let str = `${s}`;
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/(VNĐ)/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  return str;
};

export const removeAllSpace = (s: string) => {
  return s.replace(/\s/g, '');
};

export const objectToArray = (a: Object) => {
  if (!a) {
    return [];
  }
  return Object.keys(a)?.map((item: any, index: number) => {
    return a[item] || null;
  });
};

export const timeoutFromNow = (
  timeOut: number,
  I18nState: 'en' | 'vi' | string,
) => {
  let abc = timeOut;
  const h = Math.floor(abc / 3600);
  abc = abc % 3600;
  const m = Math.floor(abc / 60);
  abc = abc % 60;
  const s = abc;
  if (I18nState == 'vi') {
    return `${h > 0 ? h : 0} giờ ${m > 0 ? m : 0} phút ${s > 0 ? s : 0} giây`;
  }
  return `${h > 0 ? h : 0} h ${m > 0 ? m : 0} m ${s > 0 ? s : 0} s`;
};

export const convertStringTime = (time: string) => {
  return time
    .split('/')
    .reverse()
    .map((item: any) => {
      return parseInt(item) < 10 && item.length < 2
        ? `0${parseInt(item)}`
        : item;
    })
    .join('');
};

export const getAddressRejectWard = (address: string) => {
  const a = removeUtf8(address?.toLocaleLowerCase());
  const index = a.indexOf('xa');
  const indexgg = a.indexOf('phuong');
  if (index != -1) {
    return address?.slice(0, index).replace(/,/g, '');
  } else if (indexgg != -1) {
    return address?.slice(0, indexgg).replace(/,/g, '');
  }
  return '';
};

export const callPhone = (phone: string) => {
  const phoneNumber =
    Platform.OS === 'android' ? `tel:${phone}` : `telprompt:${phone}`;
  return Linking.openURL(phoneNumber);
};

export const linkToWeb = (t: string) => {
  Linking.canOpenURL(t)
    .then((e: any) => {
      Linking.openURL(t);
    })
    .catch((e: any) => {
      Toast.show({
        content: `alert.daxayraloi`,
        multilanguage: true,
      });
    });
};

export const copyToClipboard = async (text: string) => {
  await Clipboard.setStringAsync(text);
  Toast.show({
    content: `alert.dasaochepvaobonhodem`,
    multilanguage: true,
  });
};

export const checkLogin = (p: {name: string; pass: string}) => {
  if (p.name.length == 0) {
    Alert.showError({
      content: `alert.vuilongnhaptendangnhap`,
    });
    return false;
  }
  if (p.pass.length == 0) {
    Alert.showError({
      content: `alert.vuilongnhapmatkhau`,
    });
    return false;
  }
  return true;
};

// export function getMaxMinNAV(t: Array<any>) {
//   let max = null;
//   let min = null;
//   t.map((item: any, index: number) => {
//     if (!max) {
//       max = item.y;
//     } else if (item.y >= max) {
//       max = item.y;
//     }
//     if (!min) {
//       min = item.y;
//     } else if (item.y <= min) {
//       min = item.y;
//     }
//   });
//   return {
//     max: max || 10000,
//     min: min || 0,
//     space: (max || 10000) / 3,
//   };
// }

export function Log(t?: string | object, r?: any) {
  if (__DEV__) {
    if (typeof t == 'string') {
      return console.log(t, r || '');
    } else if (typeof t == 'object') {
      return console.log(t);
    } else {
      return console.log(t || '', r || '');
    }
  }
  return;
}

export function convertStringFeeSell(p: {
  beginValue?: number;
  endValue?: number;
  I18nState?: 'vi' | 'en';
}) {
  let content = '';
  if (p.beginValue == 0) {
    content = `${p.I18nState == 'vi' ? 'Dưới' : 'Under'} ${p.endValue} ${
      p.I18nState == 'vi' ? 'ngày' : 'days'
    }`;
  } else if (p.beginValue == 730) {
    content = `${p.I18nState == 'vi' ? 'Trên' : 'Above'} ${p.beginValue} ${
      p.I18nState == 'vi' ? 'ngày' : 'days'
    }`;
  } else if (p.endValue == -1) {
    content = `${p.I18nState == 'vi' ? 'Trên' : 'Above'} ${p.beginValue} ${
      p.I18nState == 'vi' ? 'ngày' : 'days'
    }`;
  } else {
    content = `${p.beginValue} - ${p.endValue} ${
      p.I18nState == 'vi' ? 'ngày' : 'days'
    }`;
  }
  return content;
}
export function convertStringFeeBuy(p: {
  beginValue?: number;
  endValue?: number;
  I18nState?: 'vi' | 'en';
}) {
  const {beginValue, endValue, I18nState} = p;
  if (beginValue == 0 && endValue == -1) {
    return `Từ ${convertNumber(beginValue)}`;
  }
  if (endValue == -1) {
    return `Từ ${convertNumber(beginValue || 0, true)}`;
  }
  if (beginValue == 0) {
    return `Dưới ${convertNumber(endValue || 0, true)}`;
  }

  return `${convertNumber(beginValue || 0, true)} - ${convertNumber(
    endValue || 0,
    true,
  )}`;

  // if (p.beginValue == 0) {
  //   content = `${p.I18nState == 'vi' ? 'Dưới' : 'Under'} ${p.endValue} ${
  //     p.I18nState == 'vi' ? 'ngày' : 'days'
  //   }`;
  // } else if (p.beginValue == 730) {
  //   content = `${p.I18nState == 'vi' ? 'Trên' : 'Above'} ${p.beginValue} ${
  //     p.I18nState == 'vi' ? 'ngày' : 'days'
  //   }`;
  // } else {
  //   content = `${p.beginValue} - ${p.endValue} ${
  //     p.I18nState == 'vi' ? 'ngày' : 'days'
  //   }`;
  // }
  // return content;
}

export function hidePhoneNumberOTP(t?: string) {
  if (!t?.length) {
    return '';
  }
  return [...t]
    .map((item: any, index: number) => {
      if (index <= 3 || index >= t.length - 2) {
        return item;
      }
      return '*';
    })
    .join('');
}

export const getFileUrl = async (
  file: any,
  fileName: string,
): Promise<string | undefined> => {
  try {
    const formdata = new FormData();
    formdata.append('file', file);

    const token = await getStoreToken();
    const url = `${urlApp.APIURL}api/download/file-for-link?token=${token}&origin=${urlApp.DomainName}&uri=${fileName}`;
    return url;
  } catch (error) {
    Log('error>>', error);
  }
};
